import gql from 'graphql-tag'

export const UPDATE_CUSTOMER = gql`
  mutation ($input: UpdateCustomerInput!) {
    updateCustomer(input: $input) {
      customer {
        id
      }
    }
  }
`
export const CREATE_CUSTOMER = gql`
mutation ($input: CreateCustomerInput!) {
  createCustomer(input: $input) {
    customer {
      id
      name
      tel
      address
      taxable
      taxId
      customerCategoryId
    }
  }
}
`

export default {
  UPDATE_CUSTOMER,
  CREATE_CUSTOMER
}
